<template>
    <admin-dashboard-layout>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col>
                        <h1>{{ $t('Edit Setting') }}</h1>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn text :to="{name: 'admin.settings.index'}">return</v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <from-request @submit="handleUpdate" :setting-data="setting" :errors="errors" />
            </v-card-text>
        </v-card>
    </admin-dashboard-layout>
</template>

<script>
import AdminDashboardLayout from "@/layouts/AdminDashboardLayout";
import FromRequest from "@/views/admin/settings/FromRequest";
import Settings from "@/models/admin/Settings";

export default {
    name: "settings-edit",
    components: {
        FromRequest,
        AdminDashboardLayout,
    },
    data() {
        return {
            setting: {},
            errors: {},
        }
    },
    methods: {
        handleUpdate({key, value}) {
            this.setting.key = key
            this.setting.value = value
            this.setting.patch().catch(({response}) => {
                if (response.status === 422) {
                    this.errors = response.data.errors
                }
            })
            this.$store.commit('showSnackBar', this.$t('messages.success'))
            this.$router.push({name: 'admin.settings.index'})
        },
        fetchSetting(id) {
            Settings
                .find(id)
                .then(setting => this.setting = setting)
        },
    },
    created() {
        this.fetchSetting(this.$route.params.id)
    },
}
</script>

<style lang="scss">
</style>
